export enum OktaSessionNames {
  CALLBACK_ROUTE = 'okta-callback-route',
  PROFILE = 'okta-profile',
  TRIGGER = 'okta-login-trigger',
}

export enum OktaFranklinIds {
  ONE_ID = 'oneFranklinId',
  INTERNAL_ID = 'internalFranklinId',
}
